import { FormEditedData } from '90.quickConnect.Models/models';

/**
 * Déclaration de l'historique d'un équipement. L'UO de saisie est renvoyée par l'API sous la clé « OUCode »
 * (JsonProperty de FormEditedDataDto) : elle est reprise dans ouCode pour le contrôle d'UO de la duplication
 */
const mapQCHistoricalData = (historicalData: FormEditedData & { OUCode?: string }): FormEditedData =>
  ({
    ouCode: historicalData.OUCode ?? historicalData.ouCode,
    id: historicalData.id,
    activityId: historicalData.activityId,
    alertLevelLabel: historicalData.alertLevelLabel,
    alertLevelValue: historicalData.alertLevelValue,
    eTag: historicalData.eTag,
    editedAt: historicalData.editedAt,
    editedData: historicalData.editedData,
    entityInstanceId: historicalData.entityInstanceId,
    entityInstanceStringExtract: historicalData.entityInstanceStringExtract,
    entitySchemaId: historicalData.entitySchemaId,
    formId: historicalData.formId,
    formType: historicalData.formType,
    itemDataStatus: historicalData.itemDataStatus,
    name: historicalData.name,
    organizationalUnitStringExtract: historicalData.organizationalUnitStringExtract,
    serializedBody: historicalData.serializedBody,
    stringExtract: historicalData.stringExtract,
    userUpn: historicalData.userUpn,
    workflowStatus: historicalData.workflowStatus,
  } as FormEditedData);

export default mapQCHistoricalData;
